function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M15.61 4.09L6.65 9.112M7.791 14.439c.214.889.32 1.333.543 1.493a.738.738 0 00.668.1c.26-.088.492-.482.956-1.27l5.586-9.481c.344-.584.516-.876.492-1.115a.738.738 0 00-.299-.524c-.194-.142-.533-.142-1.21-.142H3.714c-.9 0-1.35 0-1.557.178a.738.738 0 00-.255.62c.022.273.342.59.98 1.222l3.234 3.204c.148.147.222.22.282.304.053.073.098.153.133.237.04.094.065.195.114.398L7.79 14.44z",
  strokeLinejoin: "round",
  strokeWidth: 1.25
});

var SvgThreadsShare = function SvgThreadsShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-label": "Share",
    viewBox: "0 0 18 18",
    stroke: "#424242",
    fill: "transparent"
  }, props), _ref);
};

export default SvgThreadsShare;